module.exports = __webpack_public_path__ + "img/back5.c30fd90e.png";